function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 49,
  height: 49,
  stroke: "#2D577D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7905 34.5131L22.2518 30.25L27.1745 30.25L29.6358 34.5131L27.1745 38.7763L22.2518 38.7763L19.7905 34.5131Z",
  fill: "#047E2E",
  fillOpacity: 0.5,
  stroke: "#047E2E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7905 24.5131L22.2518 20.25L27.1745 20.25L29.6358 24.5131L27.1745 28.7763L22.2518 28.7763L19.7905 24.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7905 29.5131L13.2518 25.25L18.1745 25.25L20.6358 29.5131L18.1745 33.7763L13.2518 33.7763L10.7905 29.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7905 29.5131L31.2518 25.25L36.1745 25.25L38.6358 29.5131L36.1745 33.7763L31.2518 33.7763L28.7905 29.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7905 24.5131L40.2518 20.25L45.1745 20.25L47.6358 24.5131L45.1745 28.7763L40.2518 28.7763L37.7905 24.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.7905 24.5131L4.25183 20.25L9.17448 20.25L11.6358 24.5131L9.17448 28.7763L4.25183 28.7763L1.7905 24.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7905 14.5131L22.2518 10.25L27.1745 10.25L29.6358 14.5131L27.1745 18.7763L22.2518 18.7763L19.7905 14.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    className: "bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9fb11e0e.svg";
export { ForwardRef as ReactComponent };